import { Inject } from '@odinjs/odin';

import { PanelAPI, TableAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnClick } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { isEmptyArrayOrObject, isEmptyObject } from '@philips-emr/tws-utils';

import { LocatorServiceAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.LOCATOR_SERVICE })
class LocatorServiceController extends BaseController {

  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext!: SubmittableFragmentContext;
  @Inject(Aliases.TABLE)
  private table: TableAPI;
  @Inject(Aliases.PANEL_PAGINATOR)
  private panelPaginator: PanelAPI;

  @OnAfterFetch(Aliases.FETCH_SERVICES)
  OnAfterFetch(event: FetchEvent): void {
    const data = event.data as FetchEvent;
    const isEmpty = isEmptyArrayOrObject(data);
    this.panelPaginator.setVisible(!isEmpty);
  }

  @OnClick(Aliases.BUTTON_SELECT)
  onClick(): void {
    const [selected] = this.table.getSelectedRows() || [];

    if (!isEmptyObject(selected)) {
      this.submittableFragmentContext.submit(new SubmitEvent({ record: selected }));
    }
  }
}

export {
  LocatorServiceController,
};
